import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { ArrayResponse, BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TxSubscriberService {

  constructor(private http: HttpClient) { }

  getAll(filter: any): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/tx/subscriber/list`, filter)
    .pipe(
      map((data: any) => {
        if(data.status !== 1 || (data.status == 1 && !data.data.list)){
          return {status: null, msg: data.msg };
        }else{
          return data;
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

}
